import { useEffect } from 'react'
import { __ListViewMode } from '../../../common/Dictionaries';

const useUpdateSectionPartyData = (usersBookData, setUsersBookData, filtredPartyArray, setFiltredPartyArray, inputParam_SelectedSectionCardId, tglListViewMode, inputParam_SectionCardIsSelected, inputParam_SetSectionCardIsSelected) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                const _subList = usersBookData.data.filter(x => x["sectionId"] === inputParam_SelectedSectionCardId);
                setFiltredPartyArray(usersBookData.data && tglListViewMode === __ListViewMode.Specific ? {fireUpdate: true, data: _subList, pageNumber: 1, pageSize: 10, filters: []} : { fireUpdate: false, data: null })
                
                inputParam_SetSectionCardIsSelected && inputParam_SetSectionCardIsSelected(false)

                setUsersBookData(prevState => ({
                    ...prevState,
                    fireUpdate: false
                }));
            }
            catch (error) {
            }
        }
        
        if (usersBookData.data !== null && (inputParam_SelectedSectionCardId !== null && inputParam_SectionCardIsSelected === true && tglListViewMode === __ListViewMode.Specific)) {
            getData()
        }
    }, [usersBookData, setUsersBookData, filtredPartyArray, setFiltredPartyArray, inputParam_SelectedSectionCardId, tglListViewMode, inputParam_SectionCardIsSelected, inputParam_SetSectionCardIsSelected]);
}

export {
    useUpdateSectionPartyData
}